export default __webpack_public_path__ + "static/media/Menu-Cover.fc61a116.jpg";